import { PageBreadcrumbs } from "@/shared/components";

import {
  useEphemeralWorkspaceState,
  useWorkspaceSessions,
} from "../../WorkspaceCtx/hooks";

import { DatasetInfo } from "./DatasetInfo";
import { FileInfo } from "./FileInfo";
import { SessionInfo } from "./SessionInfo";

export function DatasourceInfo() {
  const { isDataLoading, files } = useEphemeralWorkspaceState();

  // When the workspace was opened from sessions, the first segment names the
  // sessions instead of their datasets. The records come from the same sessions
  // the Files tab groups by.
  const sessions = useWorkspaceSessions().map((session) => session.record);

  const datasetIds = [
    ...new Set<string>(
      files.map((f) => f.association_id).filter((id) => id !== undefined),
    ),
  ];

  return (
    <PageBreadcrumbs>
      {sessions.length > 0 ? (
        <SessionInfo sessions={sessions} />
      ) : (
        <DatasetInfo
          isDatasetsLoading={isDataLoading}
          datasetIds={datasetIds}
        />
      )}
      <FileInfo isFilesLoading={isDataLoading} files={files} />
    </PageBreadcrumbs>
  );
}
